import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import dayjs from 'dayjs'
import type { MyProfile } from '@/types/profile'
import { MyProfileEntity } from '@/entities/MyProfile'

export const useProfileStore = defineStore('profile', () => {
  // State
  const profileData = ref<MyProfile>()

  // Getters
  const isSignedIn = computed(() => !!profileData.value)
  const profile = computed(() => profileData.value && new MyProfileEntity(profileData.value))
  const uid = computed(() => profile.value?.data.uid)

  // 本日時点で18歳以上であるか否か
  // Reference: https://docs.google.com/spreadsheets/d/1Hh1M49TT8sJRGC0i6X5rvPWk296CGsKNhIbtDx4p7Hk/edit#gid=573002818&range=N24
  const isUnderage = computed<boolean>(() => {
    if (!profile.value) return true
    const now = dayjs()
    const age = now.diff(profile.value.birthday, 'year')
    return age < 18
  })

  // Actions
  const setProfileData = (data: MyProfile) => {
    profileData.value = data
  }

  return {
    uid,
    profileData,
    profile,
    setProfileData,
    isSignedIn,
    isUnderage
  }
})

export type ProfileStore = ReturnType<typeof useProfileStore>
